// extracted by mini-css-extract-plugin
export var def = "SVGSprite_def__u7c59";
export var iconWrapper = "SVGSprite_iconWrapper__uS4Wm";
export var iconWrapperBlack = "SVGSprite_iconWrapperBlack__BFANN";
export var sl = "SVGSprite_sl__M+V-Z";
export var table = "SVGSprite_table__BlVzm";